import React from 'react';

export function Alert({ message }) {
  return (
<dia-loader-overlay>{message}</dia-loader-overlay>
  );
}
